<template>
  <div class="lw-y-modal-mask" v-show="visible" :style="{ 'z-index': zIndex }">
    <div
      class="lw-y-modal"
      :style="{ width: width + 'px', height: height + 'px' }"
      :class="{ 'lw-y-modal-prompt': prompt }"
    >
      <div
        :class="[`lw-y-modal-header--${type}`, `lw-y-modal-header--${size}`]"
      >
        <span class="header-title" :title="title">{{ title }}</span>
        <span
          class="header-close iconfont lwicon-_close"
          @click="onCancel"
        ></span>
      </div>
      <div
        class="lw-y-modal-body"
        :style="{ height: footer ? 'calc(100% - 140px)' : 'calc(100% - 70px)' }"
      >
        <slot name="body"></slot>
      </div>

      <div
        class="lw-y-modal-footer"
        slot="footer"
        v-if="!$slots.footer && footer"
      >
        <lw-button @click="onCancel" style=" margin-right: 20px;"
          >取消</lw-button
        >
        <lw-button type="primary" @click="onOk">确定</lw-button>
      </div>

      <slot name="footer" v-if="$slots.footer"></slot>
      <!--      <div class="lw-y-modal-footer" name="footer" v-if="$slots.footer">-->

      <!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: {
    prompt: { type: Boolean, default: false },
    //primary
    type: { type: String, default: "" },
    //medium / small / mini
    size: { type: String, default: "medium" },
    zIndex: { type: Number, default: 999 },
    title: { type: String, default: "" },
    visible: { type: Boolean, default: false },
    width: { type: Number, default: 600 },
    height: { type: Number, default: 480 },
    footer: { type: Boolean, default: true }
  },
  methods: {
    onCancel() {
      this.$emit("onCancel");
    },
    onOk() {
      this.$emit("onOk");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/index";

@mixin lw-y-modal-header {
  display: flex;
  font-size: 14px;
  line-height: 55px;
  height: 55px;
  justify-content: flex-end;
  border-bottom: solid 1px #dddddd;

  .header-title {
    margin-left: 40px;
    display: block;
    font-size: 16px;
    width: calc(100% - 80px);
    padding: 0 20px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .header-close {
    display: block;
    width: 20px;
    cursor: pointer;
    margin-right: 20px;
    font-size: 20px;
  }

  .header-close:before {
    font-size: 20px;
  }

  .header-close:hover {
    color: #226cfb;
  }
}

.lw-y-modal-mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;

  .lw-y-modal {
    background-color: #ffffff;
    box-shadow: 0px 8px 12px 0px rgba(7, 0, 2, 0.3);
    border-radius: 6px;
    /*border: solid 1px #dddddd;*/
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    .lw-y-modal-header--medium {
      @include lw-y-modal-header;
    }

    .lw-y-modal-header--primary {
      background-color: #226cfb;
      color: #ffffff;

      .header-close:hover {
        color: #ffffff !important;
      }
    }

    .lw-y-modal-header--small {
      @include lw-y-modal-header;
      font-size: 14px;
      line-height: 40px;
      height: 40px;
      .header-title {
        font-size: 14px;
      }

      .header-close {
        width: 16px;
        height: 16px;
        font-size: 16px;
      }

      .header-close:before {
        font-size: 16px;
      }
    }

    &-prompt {
      .lw-y-modal-header--medium {
        @include lw-y-modal-header;
        font-size: 18px;
        line-height: 45px;
        height: 45px;
        .header-title {
          font-size: 18px;
        }

        .header-close {
          width: 18px;
          height: 18px;
          font-size: 18px;
        }

        .header-close:before {
          font-size: 18px;
        }
      }

      .lw-y-modal-body {
        margin: 10px 25px 20px !important;
      }
    }

    .lw-y-modal-body {
      text-align: left;
      height: calc(100% - 140px);
      margin: 20px 20px;
      @include scroll-bar(6px);
      overflow-x: hidden;
      overflow-y: auto;
    }

    .lw-y-modal-footer {
      height: 50px;
      background-color: #ffffff;
      box-shadow: 0px -1px 0px 0px #dddddd;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
